import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import React from 'react';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { buildFacetDesignOverrideLite, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import { Progress } from 'Packages/FacetDesign/Components/Progress';
import { FDBox } from '@facet-wealth/design';

const metaOverrides = buildFacetDesignOverrideLite()
  .nameOverride(['progress'], {
    _component: () => Progress,
    _customProps: {
      label: '',
    },
  }, overrideReadOnly);

export const ProgressBar = () => {
  const { resource } = useMetaLayoutContext();

  const progressResource = (resource.attr('sections')) ? resource : resource.attr('progress')?.resources()?.head();

  return (
    progressResource ? (
      <FDBox width={300} alignSelf={'center'}>
        <MetaControl resource={progressResource} attrName={'progress'} metaOverrideSet={metaOverrides} />
      </FDBox>) : null
  );
};
